/**
 *
 */
export function hasValue(field) {
	return !!field.value;
}
